var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('Editor',{attrs:{"module":"patient","file":_vm.file,"filename":_vm.filename,"name":_vm.name,"imageUrl":_vm.imageUrl,"entityId":_vm.entityId},on:{"close":_vm.closeImageEditor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }